module.exports = __webpack_public_path__ + "static/img/Team_spirit1.f078c0d.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/Team_spirit1.png
// module id = WjfV
// module chunks = 0